import Vue from 'vue'
import VueI18n from 'vue-i18n'

/** Languages */
import it from './locales/it'
import en from './locales/en'

Vue.use(VueI18n)

const messages = {
  it: it,
  en: en,
}

const locale = localStorage.getItem('currentLocale') ? localStorage.getItem('currentLocale') : 'it'

export default new VueI18n({
  locale: locale,
  fallbackLocale: 'it',
  messages,
})